export const isGithubRepositoryUrl = value => {
    try {
        const url = new URL(value);
        if (!['http:', 'https:'].includes(url.protocol) || !['github.com', 'www.github.com'].includes(url.hostname) || url.username || url.password || url.port) return false;
        const parts = url.pathname.replace(/\/$/, '').split('/').slice(1);
        if (parts.length !== 2) return false;
        const [owner, rawRepo] = parts;
        if (['about', 'collections', 'contact', 'events', 'features', 'issues', 'marketplace', 'notifications', 'orgs', 'pulls', 'search', 'settings', 'sponsors', 'topics', 'trending', 'users'].includes(owner.toLowerCase())) return false;
        const repo = rawRepo.replace(/\.git$/, '');
        return /^[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/.test(owner) && /^[a-zA-Z0-9_.-]+$/.test(repo) && !['.', '..'].includes(repo);
    } catch {
        return false;
    }
};
